import { Link, useLocation } from "react-router-dom";
import { LuArrowLeft, LuX } from "react-icons/lu";
import Page from "../../components/page/Page";
import styles from "./PaymentFailure.module.css";

const pageClasses = {
    container: styles.page,
    content: styles.pageContent,
    contentSkinny: styles.pageContent,
    title: styles.pageTitle,
};

function PaymentFailure() {
    const { state } = useLocation();

    return (
        <Page title="Payment Failed" skinny={true} pageClassesOverride={pageClasses}>
            <section className={styles.failure}>
                <div className={styles.failureIcon} aria-hidden="true"><LuX /></div>
                <p className={styles.eyebrow}>Payment not completed</p>
                <h2>You need to try again.</h2>
                <p className={styles.message}>
                    {state?.message || "Your card was not charged. Check your payment details and try the payment again."}
                </p>
                <div className={styles.actions}>
                    <Link className={styles.retry} to="/checkout">
                        <LuArrowLeft aria-hidden="true" />
                        Try again
                    </Link>
                    <Link className={styles.collection} to="/home#top">Return to collection</Link>
                </div>
            </section>
        </Page>
    );
}

export default PaymentFailure;